var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99999H16.2667C15.9025 9.99921 15.5481 10.1177 15.2576 10.3375C14.9672 10.5572 14.7567 10.866 14.6584 11.2167L12.7 18.1833C12.6874 18.2266 12.6611 18.2646 12.625 18.2917C12.589 18.3187 12.5451 18.3333 12.5 18.3333C12.4549 18.3333 12.4111 18.3187 12.375 18.2917C12.339 18.2646 12.3126 18.2266 12.3 18.1833L7.70002 1.81666C7.6874 1.77338 7.66108 1.73537 7.62502 1.70832C7.58896 1.68128 7.5451 1.66666 7.50002 1.66666C7.45494 1.66666 7.41108 1.68128 7.37502 1.70832C7.33896 1.73537 7.31264 1.77338 7.30002 1.81666L5.34169 8.78332C5.24374 9.13262 5.0345 9.44042 4.74574 9.66C4.45698 9.87958 4.10445 9.99895 3.74169 9.99999H1.66669",
    stroke: "#162D4F",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.09ddda00ce98b22909be0ebcf0af5bec.svg";
export { ForwardRef as ReactComponent };